var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('binds-popover',{attrs:{"binds-settings":_vm.popperSettings,"binds-active":_vm.shouldRender}},[(_vm.shouldRender)?_c('transition',{attrs:{"name":"binds-tooltip"}},[_c('div',{staticClass:"binds-tooltip",class:[_vm.tooltipClasses, _vm.$bindsActiveTheme],style:(_vm.tooltipStyles)},[_vm._t("default")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }